/* MHSys Quelle Geschenkefinder (Roadmap 3.24 C), Suche (06.10.2026) und Adventskalender (15.10.2026) - markiert
 * Warenkorb-Zeilen mit _quelle.
 *
 * Der Geschenkefinder (assets/mhsys-geschenkefinder.js) merkt sich jeden Klick auf einen Treffer als
 * Handle in sessionStorage (mhsysFinderKlicks bzw. mhsysFinderKlicksWeihnachten, je max. 20).
 * Kommt eines dieser Produkte in derselben Sitzung in den Warenkorb - egal ueber welchen Weg
 * (Kaufformular, Kachel, "Haeufig zusammen gekauft", Merkliste, Express) -, bekommt die Zeile
 * _quelle = geschenkefinder bzw. geschenkefinder-weihnachten. mhsys (core/orders_import.inc.php,
 * bestellung_quelle()) schreibt das nach orders_positionen.orpo_quelle; ausgewertet unter MARKETING.
 *
 * Deshalb EIN Eingriff an fetch statt einer Aenderung an jedem Kaufweg: POST auf /cart/add(.js) wird
 * nur dann angefasst, wenn eine Finder-Liste nicht leer ist - ohne Finder-Klick bleibt alles wie vorher.
 * Der Finder schlaegt eine andere Quelle (warenkorb, merkliste, produktempfehlung): der Klick im Finder
 * war der Anlass, der Rest nur der Weg. Weihnachten schlaegt den allgemeinen Finder.
 *
 * Handle -> Varianten-IDs ueber /products/<handle>.js, gepuffert in sessionStorage mhsysFinderVarianten;
 * vorgeladen beim Seitenaufruf, beim Einlegen hoechstens 1,5 s gewartet - danach geht der Aufruf
 * unmarkiert raus (lieber eine fehlende Zaehlung als ein haengender Warenkorb-Knopf).
 */
(() => {
  'use strict';

  /* Reihenfolge = Vorrang. Die Suche (06.10.2026, mhsysSucheKlicks aus assets/mhsys-kopf.js) zuletzt: wer im Finder
     klickte und dasselbe Produkt danach suchte, kam ueber den Finder */
  const LISTEN = [
    /* Adventskalender-Seite (15.10.2026, sections/mhsys-advent.liquid): der Klick aufs Angebot des Tages - zuerst, das
       Säckchen war der Anlass */
    ['mhsysAdventKlicks', 'adventskalender'],
    ['mhsysFinderKlicksWeihnachten', 'geschenkefinder-weihnachten'],
    ['mhsysFinderKlicks', 'geschenkefinder'],
    ['mhsysSucheKlicks', 'suche'],
  ];
  const PUFFER = 'mhsysFinderVarianten';
  const WARTEN_MS = 1500;
  const ADD_URL = /\/cart\/add(\.js)?(\?|$)/;

  function lesen(schluessel, leer) {
    try {
      return JSON.parse(sessionStorage.getItem(schluessel) || leer);
    } catch (e) {
      return JSON.parse(leer);
    }
  }

  function handles() {
    const alle = [];
    LISTEN.forEach(([schluessel]) => lesen(schluessel, '[]').forEach((h) => { if (!alle.includes(h)) alle.push(h); }));
    return alle;
  }

  const wurzel = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const fetchAlt = window.fetch;
  let laden = null;

  /* {handle: [variantId, ...]} fuer alle Finder-Handles; fehlende werden nachgeladen */
  function variantenLaden() {
    const puffer = lesen(PUFFER, '{}');
    const fehlen = handles().filter((h) => !Array.isArray(puffer[h]));
    if (!fehlen.length) return Promise.resolve(puffer);
    if (laden) return laden;
    laden = Promise.all(fehlen.map((h) =>
      fetchAlt.call(window, `${wurzel}products/${encodeURIComponent(h)}.js`)
        .then((r) => (r.ok ? r.json() : null))
        .then((p) => { puffer[h] = p && Array.isArray(p.variants) ? p.variants.map((v) => Number(v.id)) : []; })
        .catch(() => {})
    )).then(() => {
      try { sessionStorage.setItem(PUFFER, JSON.stringify(puffer)); } catch (e) {}
      laden = null;
      return puffer;
    });
    return laden;
  }

  /* Varianten-ID -> Quelle; Weihnachten zuerst, der allgemeine Finder ueberschreibt sie nicht */
  function zuordnung(puffer) {
    const karte = {};
    LISTEN.forEach(([schluessel, quelle]) => {
      lesen(schluessel, '[]').forEach((h) => (puffer[h] || []).forEach((id) => { if (!karte[id]) karte[id] = quelle; }));
    });
    return karte;
  }

  function markieren(body, karte) {
    if (body instanceof FormData) {
      const q = karte[Number(body.get('id'))];
      if (q) body.set('properties[_quelle]', q);
      return body;
    }
    if (typeof body !== 'string') return body;
    let daten;
    try { daten = JSON.parse(body); } catch (e) { return body; }
    if (!daten || typeof daten !== 'object') return body;
    const posten = Array.isArray(daten.items) ? daten.items : [daten];
    let geaendert = false;
    posten.forEach((p) => {
      const q = p && karte[Number(p.id)];
      if (q) { p.properties = Object.assign({}, p.properties || {}, { _quelle: q }); geaendert = true; }
    });
    return geaendert ? JSON.stringify(daten) : body;
  }

  window.fetch = function (eingabe, init) {
    try {
      const url = typeof eingabe === 'string' ? eingabe : eingabe && eingabe.url;
      const methode = String((init && init.method) || 'GET').toUpperCase();
      if (methode === 'POST' && init && init.body && ADD_URL.test(url || '') && handles().length) {
        /* Jeder Fehler hier (sessionStorage gesperrt, kaputter Puffer, Netz) laesst den Aufruf
           unveraendert rausgehen: markiert wird nur eine Kopie von init, das Original bleibt Rueckfall */
        const original = init;
        const zeit = new Promise((fertig) => setTimeout(() => fertig(null), WARTEN_MS));
        return Promise.race([variantenLaden(), zeit])
          .then((puffer) => {
            try {
              return puffer ? Object.assign({}, original, { body: markieren(original.body, zuordnung(puffer)) }) : original;
            } catch (e) {
              return original;
            }
          }, () => original)
          .then((neu) => fetchAlt.call(window, eingabe, neu));
      }
    } catch (e) {}
    return fetchAlt.apply(this, arguments);
  };

  try {
    if (handles().length) variantenLaden().catch(() => {});
  } catch (e) {}
})();
